import React, { useReducer, useEffect } from 'react';
import PropTypes from 'prop-types';

import { setTranslations } from './translationActions';
import { translationReducer, T10S_DEFAULT_STATE } from './translationReducer';
import { api, t10s } from '../services';
import { TranslationObjectDefinition } from '../utility/constants';

export const TranslationContext = React.createContext(undefined);
TranslationContext.displayName = 'TranslationContext';

const TranslationProvider = ({ translations, children }) => {
	const [_t10s, dispatch] = useReducer(translationReducer, T10S_DEFAULT_STATE, undefined);

	useEffect(() => {
		api.get(translations)
			.then(response => {
				const contentType = response.headers['content-type'];
				if (contentType && contentType.indexOf('application/json') !== -1) {
					dispatch(setTranslations(t10s(response.data.t10s)));
				}
			})
			.catch(() => {
				// ignore
			});
	}, [translations, dispatch]);

	const { Provider } = TranslationContext;

	return <Provider value={_t10s}>{children}</Provider>;
};

TranslationProvider.propTypes = {
	translations: TranslationObjectDefinition,
	children: PropTypes.any
};

export default TranslationProvider;
